module.exports = __webpack_public_path__ + "static/media/README.53ba4352.md";